import { POSTGRESQL_ENGINE } from "./sql-connection-engines";
import { createSqlConnectionForm } from "./sql-connection-form";

/** PostgreSQL. Everything but the engine spec lives in `sql-connection-form.tsx`. */
const createConnectionPostgresql = createSqlConnectionForm(POSTGRESQL_ENGINE);
export { createConnectionPostgresql as CreateConnectionPostgresql };
